import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material/material.module';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';


import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { VendorDashboardComponent } from './vendor-dashboard/vendor-dashboard.component';
import { RfpDetailsLinkComponent } from './rfp-details-link/rfp-details-link.component';
import { MatSelectSearchModule } from 'mat-select-search';
import { CoreModule } from '@angular/flex-layout';
import { CurrencyPipe } from '@angular/common';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { GuestuserComponent } from './login/guestuser/guestuser.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
// import { ReactiveFormsModule } from '@angular/forms';
import { VendorforgotpasswordComponent } from './vendorforgotpassword/vendorforgotpassword.component';
import { VendorverifyotpComponent } from './vendorverifyotp/vendorverifyotp.component';
import { VendorresetpaswordComponent } from './vendorresetpasword/vendorresetpasword.component';


import { CanvasJSAngularChartsModule } from "@canvasjs/angular-charts";
import { UnableloginvendorComponent } from './unableloginvendor/unableloginvendor.component';
// import { QuestionariseComponent } from './questionarise/questionarise.component';
import { NgxPrintModule } from 'ngx-print';
import { AuthInterceptor } from './shared/auth/auth.interceptor';
import { AuditInterceptor } from './shared/auth/audit-interceptor.interceptor';
import { PopopupopenComponent } from './dashboard/popopupopen/popopupopen.component';
import { ChaEntryComponent } from './cha-entry/cha-entry.component';


@NgModule({
  declarations: [
    AppComponent,
    // EmpLoginComponent,
    DashboardComponent,
    VendorDashboardComponent,
    RfpDetailsLinkComponent,
    ForgotPasswordComponent,
    GuestuserComponent,
    ResetPasswordComponent,
    VendorforgotpasswordComponent,
    VendorverifyotpComponent,
    VendorresetpaswordComponent,
    UnableloginvendorComponent,
    PopopupopenComponent,
    ChaEntryComponent,
    // AiInvoiceAnalysisComponent
    // QuestionariseComponent,

    //  VendorLoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    MatSelectSearchModule,
    CoreModule,
    ReactiveFormsModule,
    CanvasJSAngularChartsModule,
    NgxPrintModule
  ],
  providers: [CurrencyPipe, {
    provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
  }, {
      provide: HTTP_INTERCEPTORS,
      useClass: AuditInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
